import isNewConsumerApp from 'commons/isNewConsumerApp';
import isTestEnv from 'commons/isTestEnv';
import useAllOptionsNew from './useAllOptionsNew';
import useAllOptionsOld from './useAllOptionsOld';

const useAllOptions =
  isNewConsumerApp || isTestEnv() ? useAllOptionsNew : useAllOptionsOld;

export default useAllOptions;
